module.exports = __webpack_public_path__ + "static/media/MUADEE.2ffc3c87.svg";